class Website {
	constructor() {
		this.init();
	}

	init() {
		console.log(
			"%c Mécanisé avec soin par Le Petit Garage :: http://petitgarage.fr",
			"color: #da0a39; font-family: futura; text-transform:uppercase; font-weight: bold;"
		);
		this.previewBar();
		this.notification();
		this.gestionMenu();
		this.carousel();
		this.scrollTop();
		this.socialPosition();
	}

	/*************************************************************/

	notification() {
		if (document.querySelector(".notification .js-close")) {
			const btn = document.querySelector(".notification .js-close");
			const notif = document.querySelector(".notification");
			btn.addEventListener("click", () => {
				notif.classList.add("is-hidden");
			});
		}
	}

	/*************************************************************/

	gestionMenu() {
		var liCibles = document.getElementsByClassName("menu-item-has-children");
		for (var i = 0; i < liCibles.length; i++) {
			liCibles[i].addEventListener(
				"click",
				function() {
					if (this.classList.contains("open")) {
						this.classList.remove("open");
					} else {
						this.classList.add("open");
					}
				},
				false
			);
		}
	}

	/*************************************************************/

	carousel() {
		if (!document.querySelector(".js-carousel")) {
			return;
		}

		const carousels = document.querySelectorAll(".js-carousel");

		carousels.forEach(function(_el) {
			const flkty = new Flickity(_el, {
				draggable: false,
				prevNextButtons: false,
				autoPlay: 4000,
				pauseAutoPlayOnHover: true,
				bgLazyLoad: true
			});
		});
	}

	/*************************************************************/

	// Calcul de position seulement quand la barre de préview est présente
	previewBar() {
		let p = document.querySelector(".preview-header");
		if (!p) return;
		let height = p.offsetHeight;
		let elts = [
			document.querySelector(".header"),
			document.querySelector(".header-mobile"),
			document.querySelector(".nav-button"),
			document.querySelector(".content-wrapper"),
			document.querySelector("#footer"),
			document.querySelector(".navigation-general-mobile")
		];
		elts.forEach(_el => (_el.style.marginTop = `${height}px`));
		document.querySelector(".navigation-general-mobile").style.height = `calc(100vh - ${height}px)`;
	}

	/*************************************************************/

	//Smooth scroll (fleche bas de page)
	scrollTop() {
		var scrollTopElement = document.querySelector(".footer-blocDroite__scrollTop");
		if (!scrollTopElement) return;
		const scroll = new SmoothScroll();
		scrollTopElement.addEventListener("click", () => {
			scroll.animateScroll(0, {
				easing: "easeOutCubic"
			});
		});
	}

	/*************************************************************/

	socialPosition() {
		let social = document.querySelector(".single-social");
		let header = document.querySelector(".header");
		if (!social) return;
		social.style.top = header.offsetHeight / 10 + 2 + "rem";
	}

	/*************************************************************/
}

// Chargement des class externes
document.addEventListener("DOMContentLoaded", function() {
	const fixHeader = new FixHeader();
	const website = new Website();
	const statistiques = new Statistiques();
	const tableau = new Tableau();
	const compteRebours = new CompteRebours();
	const background = new Background();
});
